module.exports = __webpack_public_path__ + "static/ud_user_experience-2fad5906145afad71d26b2625dcf3860.svg";